import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { MonthProvider } from './contexts/MonthContext';
import LoginPage from './pages/LoginPage';
import BudgetPage from './pages/BudgetPage';
import TransactionsPage from './pages/TransactionsPage';
import SettingsPage from './pages/SettingsPage';
import AnalysisPage from './pages/AnalysisPage';
import AffordPage from './pages/AffordPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import BottomNav from './components/BottomNav';
import './App.css';

function AppContent() {
  const { isAuthenticated, isLoading } = useAuth();
  const [showLoading, setShowLoading] = useState(isLoading);

  // Add a small delay before hiding loading to prevent flickering
  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => setShowLoading(false), 100);
      return () => clearTimeout(timer);
    } else {
      setShowLoading(true);
    }
  }, [isLoading]);

  if (showLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">BudgetApp</h1>
          <p className="text-gray-600">Laddar...</p>
        </div>
      </div>
    );
  }

  return (
    <>
        <Routes>
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          {isAuthenticated ? (
            <>
              <Route path="/" element={<BudgetPage />} />
              <Route path="/transaktioner" element={<TransactionsPage />} />
              <Route path="/analys" element={<AnalysisPage />} />
              <Route path="/rad" element={<AffordPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/settings/*" element={<SettingsPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          ) : (
            <Route path="*" element={<LoginPage />} />
      )}
    </Routes>
      {isAuthenticated && <BottomNav />}
    </>
  );
}

function App() {
  console.log('🎯 App component rendering');
  return (
    <Router>
      <AuthProvider>
        <MonthProvider>
          <AppContent />
        </MonthProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;